import {Injectable, Injector} from '@angular/core';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalMorphologyModel} from '../../../api/model/medicalMorphology.model';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';

@Injectable({providedIn: 'root'})
export class MedicalMorphologyRepository extends AbstractRepositoryV2<MedicalMorphologyModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalMorphology', serviceElementsFactory, injector);
    }
}
